export default __webpack_public_path__ + "static/media/appmaker.4c65c1c2.svg";